<template>
    <div class="width">
        <div class="themeblock" :data-label="title">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: "tool-box",
    props: {
        title: {
            type: String,
            required: false,
            default: () => '',
        },
    }
}
</script>

<style scoped>
    .tool-box__title-container {
        display: block;
        margin: -53px 0 10px 0;
    }

    .tool-box__title {
        display: inline-block;
        color: #e9eff6;
        font-size: 24px;
        font-weight: 800;
        padding: 5px 10px;
        background-color: white;
    }

</style>
